import clientConfigApi from '../../config/config';
import { CMSPath } from '../../config/constant';

export const setIdCardImage = image => {
    return{
      type:'Set_id_image',
      payload: image
    };
  }

export const setIdCardImageBack = image => {
    return{
      type:'Set_id_image_back',
      payload: image
    };
  }

export const setCheckinWidgetLaunchTime = str => {
  return{
    type:'Set_Checkin_Widget_Launch_Time',
    payload: str
  };
}

export const setSelectedIdType = str => {
  return{
    type: 'Set_Selected_Id_Type',
    payload: str
  }
}
  
export const setSelfieVideo = image => {
    return{
        type:'Set_selfie_image',
        payload: image
    };
  }

export const setIdCardResponse = resp => {
  return {
    type: 'Set_id_resp',
    payload: resp
  };
}

export const setIdCardBackResponse = resp => {
  return {
    type: 'Set_id_back_resp',
    payload: resp
  };
}

export const setCardStatusPopupProps = obj => {
  return{
    type: 'Set_Card_Status_Popup_Props',
    payload: obj
  }
}

export const setSelfieResponse = resp => {
  return {
    type: 'Set_selfie_resp',
    payload: resp
  };
}

export const setAutoCheckedIn = bool => {
  return{
    type:'Set_auto_checkedin',
    payload: bool
  }
}

export const setBookingRef = value => {
  return{
    type:'Set_booking_ref',
    payload: value
  }
}

export const setCheckinRoomNo = value => {
  return{
    type:'Set_checkin_room_no',
    payload: value
  }
}

export const setIdRotateDeg = deg => {
  return{
    type:'Set_id_rotate_deg',
    payload: deg
  }
}

export const getAllergyOptions = (token) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try{
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,{
          "header": {
            "sessionToken": token
          },
          "payload": {
              "actionKey": "guestAllergyOptionsData"
          }
    
        }
      )
      .then(res => {
        // console.log("Allergy options guest booking",res)
        if(res.data && res.data.payload && res.data.payload.allergiesOptionList){
          dispatch({
            type:"Set_allergy_options",
            payload: res.data.payload.allergiesOptionList
          })
        }else{
          dispatch({
            type:"Set_allergy_options",
            payload: []
          })
        }
      })
      .catch(({response = {}}) => {
        console.log("Api failed with the status code:", response.status)
      })
    }catch(e){
      console.log("error in Allergies Options List api", e);
    }
  }
}


export const getCountryOptions = (token) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try{
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,{
          "header": {
            "sessionToken": token
          },
          "payload": {
            "actionKey": "checkInAddressData"
          }
    
        }
      )
      .then(res => {
        // console.log("Country options guest booking",res)
        if(res.data && res.data.payload && res.data.payload.countries){
          dispatch({
            type:"Set_country_options",
            payload: res.data.payload.countries
          })
        }else{
          dispatch({
            type:"Set_country_options",
            payload: []
          })
        }
      })
      .catch(({response = {}}) => {
        console.log("Api failed with the status code:", response.status)
      })
    }catch(e){
      console.log("error in Country Options List api", e);
    }
  }
}

export const sendConfidenceScore = (category,actionType,label) => {
  let deviceIdentifier = localStorage.getItem('deviceIdentifierFromCMS')
  console.log("SEND ANALYTICS - ", actionType)

  let InfoLabel;
    
  if(localStorage.getItem("checkinSessionBookingNumber")){
    InfoLabel = {
      ...label, 
      "deviceIdentifierFromCMS": deviceIdentifier,
      "platform": window.device ? window.device.platform : "Web",
      "bookingNumber": localStorage.getItem("checkinSessionBookingNumber"),
    }
  } else {
    InfoLabel = {
      ...label, 
      "deviceIdentifierFromCMS": deviceIdentifier,
      "platform": window.device ? window.device.platform : "Web"
    }
  }

  return async dispatch => {
    if(process.env.REACT_APP_SEND_ANALYTICS == 'false') return;
    try{
      clientConfigApi.post(
        "/deviceAnalytics/send",{
          "header": {
            // "guestToken": guestToken,
            // "locationId": locationId
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "dataSource": "guestJourney"
        },
        "payload": {
          "data": [{
            "category": category.trim().replace(/ /g,"_").replace(/-/g, "_"),
            "action": actionType,
            "label": InfoLabel,
            "value": 0,
            "appendDemographics": false
          }]
        }
      })
      .then(res => {
        console.log("success", res);
        // callback(true);
      })
      .catch(({response = {}}) => {
        console.log("Api failed with the status code:", response.status);
        // callback(false);
      })
    }catch(e){
      console.log("error in GA api", e);
    }
  }
}

export const getCardChecksData = (token, callback) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try{
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,{
          "header": {
            "sessionToken": token
          },
          "payload": {
              "actionKey": "cardChecksData"
          }
    
        }
      )
      .then(res => {
        // console.log("Allergy options guest booking",res)
        if(res.data && res.data.payload){
          dispatch({
            type:"Set_Card_Checks_Data",
            payload: res.data.payload
          })
          if(callback){
            callback(res.data.payload.guestImagesCheckEnabled)
          }
        }
      })
      .catch(({response = {}}) => {
        console.log("Api failed with the status code:", response.status)
      })
    }catch(e){
      console.log("error in Allergies Options List api", e);
    }
  }
}


export const GetDynamicBookingForm = async (callback) => {

  let DynamicBookingForm = [];

  try {

    const headerConfig = {
      headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
    };

      let response = await fetch(`${CMSPath}/Connector/rest/assets?type=preCheckInForm`, headerConfig)
      console.log("success getting dynamic booking form")
      const bookingFromPayload = await response.json();

      DynamicBookingForm = bookingFromPayload;

      callback(DynamicBookingForm);
  } catch (err) {
      console.log("Got error while getting dynamic booking form" + JSON.stringify(err))

      callback(DynamicBookingForm);
  }
}

export const getAccompanyguestDynamicBookingForm = async (callback) => {

  let DynamicBookingForm = [];

  try {

    const headerConfig = {
      headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
    };

      let response = await fetch(`${CMSPath}/Connector/rest/assets?type=preCheckInAccompanyGuestForm`, headerConfig)
      console.log("success getting dynamic booking form")
      const bookingFromPayload = await response.json();

      DynamicBookingForm = bookingFromPayload;

      callback(DynamicBookingForm);
  } catch (err) {
      console.log("Got error while getting accompany guest dynamic booking form" + JSON.stringify(err))

      callback(DynamicBookingForm);
  }
}


export const cardValidation = (actionKey, confirmationNumber, callback, lastNameCard, firstNameCard, cardIdentifier) => {
  return async dispatch => {
    try{
      await clientConfigApi.post("/mobileCheckIn/cardValidation", {
          "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "actionKey":actionKey,
          },
          "payload": {
            "confirmationNumber": confirmationNumber,
            "cardDigits": "",
            "lastNameCard": lastNameCard || "",
            "firstNameCard": firstNameCard || "",
            "cardCheckId": cardIdentifier || "",
          }  
        }).then(response => {
          if(actionKey == "register")
            callback(response.data.payload.tokenStr)
          else
            callback(true)
        }).catch(({response = {}}) => {
          console.log(response)
          if(response.data) callback(false, response.data.header && response.data.header.status)
          else callback(false, {msg: "Card validation failed!"})
        })
      } catch (error) {
        console.log("error in card validation api", error);
      }
  }
}

export const setCheckinCurrentPageName = str => {
  return {
    type: 'Set_Checkin_Current_PageName',
    payload: str
  };
}

export const setAccompanyGuestData = obj => {
  return{
    type: 'Set_AccompanyGuest_Data',
    payload: obj
  }
}

export const setAbortCheckinProcess = bool => {
  return{
    type: 'Set_Abort_Checkin_process',
    payload: bool
  }
}